import React from 'react';
import Icon from '../../../components/AppIcon';

const ComplianceIndicators = ({ requests }) => {
  const getComplianceStats = () => {
    const total = requests?.length || 0;
    const compliant = requests?.filter(r => r?.complianceStatus === 'compliant')?.length || 0;
    const violations = requests?.filter(r => r?.complianceStatus === 'violation')?.length || 0;
    const pending = requests?.filter(r => r?.complianceStatus === 'pending_review')?.length || 0;

    return {
      total,
      compliant,
      violations,
      pending,
      complianceRate: total > 0 ? Math.round((compliant / total) * 100) : 0
    };
  };

  const stats = getComplianceStats();

  const getComplianceColor = (status) => {
    switch (status) {
      case 'compliant': return 'success';
      case 'violation': return 'error';
      case 'pending_review': return 'warning';
      default: return 'muted';
    }
  };

  return (
    <div className="glass-container rounded-xl border border-border/50">
      <div className="p-6 border-b border-border/50">
        <h3 className="text-lg font-semibold text-foreground">Compliance Status</h3>
        <p className="text-sm text-muted-foreground mt-1">
          Policy compliance tracking
        </p>
      </div>
      <div className="p-6">
        {/* Compliance Rate */}
        <div className="mb-6">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-medium text-muted-foreground">Compliance Rate</span>
            <span className="text-2xl font-bold text-foreground">{stats?.complianceRate}%</span>
          </div>
          <div className="w-full h-3 bg-muted/20 rounded-full overflow-hidden">
            <div
              className="h-full bg-gradient-to-r from-success to-accent transition-all duration-500"
              style={{ width: `${stats?.complianceRate}%` }}
            />
          </div>
        </div>

        {/* Compliance Breakdown */}
        <div className="space-y-4">
          <div className="flex items-center justify-between p-3 rounded-lg bg-success/10 border border-success/20">
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-success/20">
                <Icon name="CheckCircle" size={16} className="text-success" />
              </div>
              <span className="text-sm font-medium text-foreground">Compliant</span>
            </div>
            <span className="text-lg font-bold text-success">{stats?.compliant}</span>
          </div>

          <div className="flex items-center justify-between p-3 rounded-lg bg-error/10 border border-error/20">
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-error/20">
                <Icon name="XCircle" size={16} className="text-error" />
              </div>
              <span className="text-sm font-medium text-foreground">Violations</span>
            </div>
            <span className="text-lg font-bold text-error">{stats?.violations}</span>
          </div>

          <div className="flex items-center justify-between p-3 rounded-lg bg-warning/10 border border-warning/20">
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-warning/20">
                <Icon name="Clock" size={16} className="text-warning" />
              </div>
              <span className="text-sm font-medium text-foreground">Pending Review</span>
            </div>
            <span className="text-lg font-bold text-warning">{stats?.pending}</span>
          </div>
        </div>

        {/* Recent Violations */}
        {stats?.violations > 0 && (
          <div className="mt-6 pt-6 border-t border-border/50">
            <h4 className="text-sm font-semibold text-foreground mb-3">Recent Violations</h4>
            <div className="space-y-2">
              {requests
                ?.filter(r => r?.complianceStatus === 'violation')?.slice(0, 3)?.map((request) => (
                  <div
                    key={request?.id}
                    className="p-3 rounded-lg bg-error/5 border border-error/20"
                  >
                    <div className="flex items-start justify-between">
                      <div>
                        <p className="text-sm font-medium text-foreground">{request?.requestNumber}</p>
                        <p className="text-xs text-muted-foreground mt-1">{request?.travelerName}</p>
                      </div>
                      <Icon name="AlertTriangle" size={16} className="text-error" />
                    </div>
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ComplianceIndicators;